export default __webpack_public_path__ + "static/media/wubook.d6ae125b.webp";